import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-green-100 border-t border-gray-100" id='footer'>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-sm font-medium text-gray-900 mb-2 sm:mb-4">Kigo Prints</h3>
            <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">
              Your One-Stop Solution for Quality Printing. Fast delivery, premium quality, competitive prices.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-sm font-medium text-gray-900 mb-2 sm:mb-4">Our Services</h3>
            <ul className="space-y-1.5 sm:space-y-2">
              <li><a href="/category/visiting-cards" className="text-xs sm:text-sm text-gray-600 hover:text-gray-900 transition-colors">Business Cards</a></li>
              <li><a href="/category/marketing-essentials" className="text-xs sm:text-sm text-gray-600 hover:text-gray-900 transition-colors">Flyers & Postcards</a></li>
              <li><a href="/category/custom-stationary" className="text-xs sm:text-sm text-gray-600 hover:text-gray-900 transition-colors">Stationery</a></li>
              <li><a href="/category/marketing-essentials" className="text-xs sm:text-sm text-gray-600 hover:text-gray-900 transition-colors">Marketing Materials</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-sm font-medium text-gray-900 mb-2 sm:mb-4">Contact Us</h3>
            <ul className="space-y-2 sm:space-y-2">
              <li className="text-xs sm:text-sm text-gray-600">
                <div className="flex items-start sm:items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 sm:h-5 sm:w-5 mr-1.5 sm:mr-2 text-pink-500 flex-shrink-0 mt-0.5 sm:mt-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                  <a href="tel:8080184435" className="hover:underline">80801 84435</a>
                </div>
              </li>
              <li className="text-xs sm:text-sm text-gray-600">
                <div className="flex items-start sm:items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 sm:h-6 sm:w-6 mr-1.5 sm:mr-2 text-gray-500 flex-shrink-0 mt-0.5 sm:mt-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <span className="leading-relaxed">Vinod Printers, 47, Datta Prasad Housing Society, Ganesh Nagar, Wadgaon Sheri, Pune, Maharashtra 411014</span>
                </div>
              </li>
              <li className="text-xs sm:text-sm text-gray-600">
                <div className="flex items-start sm:items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 sm:h-5 sm:w-5 mr-1.5 sm:mr-2 text-gray-500 flex-shrink-0 mt-0.5 sm:mt-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064" />
                  </svg> {/* https://www.xpressprint.in/ */}
                  <a href="https://www.kigoprints.com/" className="hover:underline break-all">www.kigoprints.com</a>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-4 sm:mt-8 pt-4 sm:pt-8 border-t border-gray-100">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 sm:gap-0">
            <div className="flex flex-col items-center md:items-start gap-2 sm:gap-0">
              <p className="text-xs sm:text-sm text-gray-600 text-center md:text-left">
                © {new Date().getFullYear()} Kigo Prints. All rights reserved.
              </p>
              <div className="flex flex-wrap items-center justify-center md:justify-start gap-3 sm:gap-4 mt-2 sm:mt-0">
                <Link to="/about-us" className="text-xs sm:text-sm text-gray-600 hover:text-gray-900 transition-colors">
                  About Us
                </Link>
                <span className="text-gray-400">|</span>
                <Link to="/terms-and-policies" className="text-xs sm:text-sm text-gray-600 hover:text-gray-900 transition-colors">
                  Terms & Policies
                </Link>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row items-center gap-1.5 sm:gap-0">
              <span className="text-xs sm:text-sm text-gray-600 text-center sm:text-left sm:mr-2">For Payment & Delivery Confirmation:</span>
              <a href="tel:8080184435" className="text-pink-500 font-medium text-xs sm:text-sm whitespace-nowrap">80801 84435</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;